/* This is the dummy DownloadManager for web, as Downloading Assets will not be supported on Browsers */

function empty() {}

async function getFileUri(url: string) {
  return url;
}

async function hasFreeStorage() {
  return true;
}

let DownloadManager = {
  downloadAssets: empty,
  stopDownload: empty,
  getFileUri: getFileUri,
  hasFreeStorage: hasFreeStorage,
};

export default DownloadManager;
